import { Hero } from "@/components/home/Hero";
import { PillarsMarquee } from "@/components/home/PillarsMarquee";
import { ProgramsPreview } from "@/components/home/ProgramsPreview";
import { ImpactStats } from "@/components/home/ImpactStats";
import { DonateCTA } from "@/components/home/DonateCTA";
import { SEO } from "@/components/SEO";

export default function Home() {
  return (
    <div data-testid="home-page">
      <SEO
        title="Home"
        description="PhysioAbhi Healthcare Foundation is a Section 8 nonprofit in Bengaluru offering free and subsidised physiotherapy for elderly people, children with special needs, and underserved athletes."
        path="/"
      />
      <Hero />
      <PillarsMarquee />
      <ProgramsPreview />
      <ImpactStats />
      <DonateCTA />
    </div>
  );
}
